// src/globalStyles.js
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  *,*::before,*::after{ box-sizing: border-box; }
  html, body, #root { height: 100%; }
  html, body {
    margin: 0;
    background: ${({theme})=>theme.bg};
    color: ${({theme})=>theme.text};
    font: 400 18px/1.6 ${({theme})=>theme.font.family};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .container { width: ${({theme})=>theme.container}; margin: 0 auto; }

  h1, h2, h3 {
    margin: 0 0 12px 0;
    letter-spacing: -0.02em;
  }
  h1 { font-size: ${({theme})=>theme.font.sizes.h1}; }
  h2 { font-size: ${({theme})=>theme.font.sizes.h2}; }
  h3 { font-size: ${({theme})=>theme.font.sizes.h3}; }

  p { margin: 0 0 12px 0; color: ${({theme})=>theme.textMuted}; }

  a { color: inherit; text-decoration: none; }
  a:hover { opacity: .9; }

  .card {
    background: ${({theme})=>theme.surface};
    border: 1px solid ${({theme})=>theme.border};
    border-radius: ${({theme})=>theme.radius.lg}px;
    box-shadow: ${({theme})=>theme.shadow.sm};
    padding: 20px;
  }

  .btn {
    display: inline-flex; align-items: center; justify-content: center;
    gap: 8px; padding: 12px 18px; font-weight: 700;
    border-radius: ${({theme})=>theme.radius.pill}px; cursor: pointer; border: 1px solid transparent;
    transition: transform .05s ease, box-shadow .2s ease, background .2s ease, color .2s ease, border-color .2s ease;
    user-select: none;
  }
  .btn:active { transform: translateY(1px); }

  .btn--primary {
    background: ${({theme})=>theme.accent}; color: #111; border-color: ${({theme})=>theme.accent};
    box-shadow: 0 8px 24px rgba(255,102,0,.35);
  }
  .btn--primary:hover { background: ${({theme})=>theme.accentDark}; }

  .btn--ghost {
    background: transparent; color: ${({theme})=>theme.text};
    border-color: ${({theme})=>theme.border};
  }
  .btn--ghost:hover { border-color: ${({theme})=>theme.textMuted}; }

  .section { padding: 72px 0; }
  .surface { background: ${({theme})=>theme.body}; }

  /* чтобы работало без явного .active у NavLink (v6): */
  a[aria-current="page"] {
    background: ${({theme})=>theme.surface};
    border: 1px solid ${({theme})=>theme.border};
    color: ${({theme})=>theme.text};
    box-shadow: ${({theme})=>theme.shadow.sm};
  }
  :root { --textMuted: ${({theme})=>theme.textMuted}; }
`;
